import { ILocationTree } from 'legacy/lut/components/shared/locationTree/LocationTree'
import { LocationTreeExtended } from 'legacy/lut/components/shared/locationTree/LocationTreeExtended'
import React from 'react'

import { useFormField } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'
import { IFormField } from 'cng-common/features/form/models'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './FormLocationTreeExtended.module.scss'

export type TFormLocationTreeExtended = Omit<IFormField<string[]>, 'validationType' | 'label'> &
  ILocationTree

export const FormLocationTreeExtended = (props: TFormLocationTreeExtended) => {
  const { validationMessage, value, handleChange } = useFormField({
    ...props,
    validationType: ValidationType.ONCHANGE,
  })
  const { label, root, hideHpOrg, isUpperCase } = props

  return (
    <Tooltip tipContent={() => <span>{validationMessage}</span>} disabled={!validationMessage}>
      <LocationTreeExtended
        label={label}
        value={value}
        onChange={handleChange}
        root={root}
        hideHpOrg={hideHpOrg}
        isUpperCase={isUpperCase}
        partnerTerritory={props.partnerTerritory}
        className={validationMessage ? styles.invalid : undefined}
        disabled={props.isDisabled}
      />
    </Tooltip>
  )
}
